const validate = values => {
  const errors = {}

  if (
    !values.calendar_events_form?.calendarEvents ||
    values.calendar_events_form?.calendarEvents.length === 0
  ) {
    errors.calendar_events_form = {
      ...errors.calendar_events_form,
      calendarEvents: "You must check at least one calendar!",
    }
  }

  return errors
}

export default validate
